// extracted by mini-css-extract-plugin
module.exports = {"modifyStudyPlanForm":"style-module__modifyStudyPlanForm___3doPV","cancelButton":"style-module__cancelButton___FovdD"};